"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringValueParser = void 0;
var string_1 = require("@devexpress/utils/lib/utils/string");
var value_info_1 = require("./value-info");
var StringValueParser = (function () {
    function StringValueParser() {
    }
    StringValueParser.parse = function (inputString) {
        return string_1.StringUtils.isNullOrEmpty(inputString) ?
            value_info_1.ValueInfo.empty :
            StringValueParser.splitUnitFromValue(inputString);
    };
    StringValueParser.splitUnitFromValue = function (inputString) {
        var value = '';
        var unit = inputString;
        var pos = inputString.search(StringValueParser.regex);
        if (pos != -1) {
            value = inputString.substr(0, pos + 1);
            unit = inputString.substr(pos + 1);
        }
        else {
            value = inputString;
            unit = '';
        }
        var val = parseFloat(value);
        return isNaN(val) ?
            new value_info_1.ValueInfo(unit) :
            new value_info_1.ValueInfo(unit, val);
    };
    StringValueParser.regex = /[123456789.](?!.*[123456789.])/;
    return StringValueParser;
}());
exports.StringValueParser = StringValueParser;
